module.exports = __webpack_public_path__ + "media/fyt_m6.cc8a56da.mp4";